import { createAction, props } from '@ngrx/store';
import { IProofBusinessFicaDocs } from '../models/business-proof-fica-doc.model';

export const loadGetProofBusinessFicaDocs = createAction(
  '[GetProofBusinessFicaDocs] Load GetProofBusinessFicaDocs',
  props<{ businessId: string }>()
);

export const loadGetProofBusinessFicaDocsSuccess = createAction(
  '[GetProofBusinessFicaDocs] Load GetProofBusinessFicaDocs Success',
  props<{ response: IProofBusinessFicaDocs[] }>()
);

export const loadGetProofBusinessFicaDocsFailure = createAction(
  '[GetProofBusinessFicaDocs] Load GetProofBusinessFicaDocs Failure',
  props<{ error: Error | any }>()
);

export const clearGetProofBusinessFicaDocs = createAction('[Clear GetProofBusinessFicaDocs] Clear GetProofBusinessFicaDocs');
